var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contain" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c("el-breadcrumb-item", [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Orders")])
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Tracking Info")])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "order-title" }, [
        _vm._v("OrderId : " + _vm._s(_vm.orderId))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "logistic-detail"
        },
        [
          _c("div", { staticClass: "logistic-order-message" }, [
            _c("div", { staticClass: "order-place" }, [
              _c("div", { staticClass: "order-place-title" }, [
                _vm._v("Order Placed")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-place-content" }, [
                _vm._v(_vm._s(_vm.dataSource.createTime))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ship-to" }, [
              _c("div", { staticClass: "ship-to-title" }, [_vm._v("Ship To")]),
              _vm._v(" "),
              _c("div", { staticClass: "ship-to-content" }, [
                _vm._v(_vm._s(_vm.dataSource.address))
              ])
            ]),
            _vm._v(" "),
            _vm.dataSource.logisticTrackDetail.length &&
            _vm.dataSource.logisticTrackDetail.length > 1
              ? _c("div", { staticClass: "logistic-order-message-right" }, [
                  _c(
                    "div",
                    { staticClass: "logistic-order-message-right-content" },
                    [_vm._v("The current order has been split and shipped")]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _vm.dataSource.logisticTrackDetail.length === 0
            ? _c("div", { staticClass: "no_data" }, [
                _vm._v("No Logistics Data")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical-demo",
              attrs: { "unique-opened": true, "default-openeds": ["0"] }
            },
            _vm._l(_vm.dataSource.logisticTrackDetail, function(item, index) {
              return _c(
                "el-submenu",
                { key: index, attrs: { index: index + "" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "logistic-children-message" }, [
                      _c(
                        "div",
                        { staticClass: "logistic-children-message-content" },
                        [
                          _c("div", { staticClass: "shipping-method" }, [
                            _c(
                              "div",
                              { staticClass: "shipping-method-title" },
                              [_vm._v("Shipping Method:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "shipping-method-content" },
                              [
                                _vm._v(
                                  _vm._s(item.shippingMethod) +
                                    ":" +
                                    _vm._s(item.trackingNumber)
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "shipping-status" }, [
                            _c(
                              "div",
                              { staticClass: "shipping-status-title" },
                              [_vm._v("Status:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "shipping-status-content" },
                              [_vm._v(_vm._s(item.trackingStatus))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "order-number" }, [
                            _c("div", { staticClass: "order-number-title" }, [
                              _vm._v("Items:")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "order-number-content" }, [
                              _vm._v(_vm._s(item.items))
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "logistic-children-imgs" },
                        [
                          _vm._l(item.skuImgPartList, function(
                            childrenItem,
                            childrenIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key: childrenIndex,
                                staticClass: "logistic-children-img"
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    height: "80px",
                                    width: "80px"
                                  },
                                  attrs: { src: childrenItem }
                                })
                              ]
                            )
                          }),
                          _vm._v(" "),
                          item.showViewAll === 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "show-view-all-true",
                                  on: {
                                    click: function($event) {
                                      return _vm.showViewAll(item, true)
                                    }
                                  }
                                },
                                [_vm._v("View All")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.showViewAll === 3
                            ? _c(
                                "div",
                                {
                                  staticClass: "show-view-all-true",
                                  on: {
                                    click: function($event) {
                                      return _vm.showViewAll(item, false)
                                    }
                                  }
                                },
                                [_vm._v("Pack Up")]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-menu-item-group",
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c(
                            "el-steps",
                            {
                              staticClass: "pc-steps",
                              attrs: {
                                active: item.active,
                                "finish-status": "success"
                              }
                            },
                            [
                              _c("el-step", {
                                attrs: {
                                  title: "Submit orders",
                                  description: _vm.dataSource.createTime
                                }
                              }),
                              _vm._v(" "),
                              _c("el-step", {
                                attrs: {
                                  title: "Payment completed",
                                  description: item.payTime
                                }
                              }),
                              _vm._v(" "),
                              _c("el-step", {
                                attrs: {
                                  title: "Warehouse delivery",
                                  description: item.deliveryStartTime
                                }
                              }),
                              _vm._v(" "),
                              _c("el-step", {
                                attrs: {
                                  title: "Delivered completed",
                                  description: item.deliveredTime
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-steps",
                            {
                              staticClass: "mobile-steps",
                              attrs: {
                                direction: "vertical",
                                active: item.active,
                                "finish-status": "success"
                              }
                            },
                            [
                              _c("el-step", {
                                attrs: {
                                  title: "Submit orders",
                                  description: _vm.dataSource.createTime
                                }
                              }),
                              _vm._v(" "),
                              _c("el-step", {
                                attrs: {
                                  title: "Payment completed",
                                  description: item.payTime
                                }
                              }),
                              _vm._v(" "),
                              _c("el-step", {
                                attrs: {
                                  title: "Warehouse delivery",
                                  description: item.deliveryStartTime
                                }
                              }),
                              _vm._v(" "),
                              _c("el-step", {
                                attrs: {
                                  title: "Delivered completed",
                                  description: item.deliveredTime
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "logistic-steps" },
                            _vm._l(item.trackDetail, function(
                              routes,
                              routesIndex
                            ) {
                              return _c(
                                "div",
                                { key: routesIndex, staticClass: "steps" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "logistic-steps-time" },
                                    [_vm._v(_vm._s(routes.eventTime))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "logistic-steps-remark" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          routes.locationOfTheIncident.replace(
                                            "null,",
                                            ""
                                          )
                                        ) +
                                          " " +
                                          _vm._s(
                                            routes.eventDescription.replace(
                                              "null,",
                                              ""
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                2
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15f92ce4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f92ce4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/logistics/logistic-detail.vue
// module id = KnV2
// module chunks = 2